/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractorListItem } from './ContractorListItem';
import {
    ContractorListItemFromJSON,
    ContractorListItemFromJSONTyped,
    ContractorListItemToJSON,
    ContractorListItemToJSONTyped,
} from './ContractorListItem';

/**
 * 
 * @export
 * @interface ResultOfIReadOnlyListOfContractorListItem
 */
export interface ResultOfIReadOnlyListOfContractorListItem {
    /**
     * 
     * @type {Array<ContractorListItem>}
     * @memberof ResultOfIReadOnlyListOfContractorListItem
     */
    data: Array<ContractorListItem> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfIReadOnlyListOfContractorListItem
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfIReadOnlyListOfContractorListItem
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfIReadOnlyListOfContractorListItem interface.
 */
export function instanceOfResultOfIReadOnlyListOfContractorListItem(value: object): value is ResultOfIReadOnlyListOfContractorListItem {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfIReadOnlyListOfContractorListItemFromJSON(json: any): ResultOfIReadOnlyListOfContractorListItem {
    return ResultOfIReadOnlyListOfContractorListItemFromJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfContractorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIReadOnlyListOfContractorListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(ContractorListItemFromJSON)),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfIReadOnlyListOfContractorListItemToJSON(json: any): ResultOfIReadOnlyListOfContractorListItem {
    return ResultOfIReadOnlyListOfContractorListItemToJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfContractorListItemToJSONTyped(value?: ResultOfIReadOnlyListOfContractorListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(ContractorListItemToJSON)),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

